const REPORT_TYPES=['FEEDBACK','BUG'];export default REPORT_TYPES;